import styled from 'styled-components';
import { Column, Row } from 'components/shared/Layout';

import { colours } from 'themes/default';

export const StyledRow = styled(Row)`
  background: ${colours.Greyscale.SilverGrey};
  border: 1px solid ${colours.Greyscale.SilverGrey};
  margin-bottom: 20px;
  padding: 20px;
`;

export const StyledColumn = styled(Column)`
  margin-top: 25px;
  position: relative;
`;

export const StyledSpan = styled('span')`
  font-size: 14px;
  color: ${(props) => (props.error ? 'red' : 'initial')};
`;

export const ErrorMessage = styled('span')`
  font-size: 14px;
  color: red;
  display: block;
`;

export const StyledLabel = styled('label')`
  display: block;
  padding-bottom: 8px;
`;

export const StyledTitle = styled('p')`
  font-size: 20px;
  padding-top: 30px;
`;

export const StyledCountriesError = styled.div`
  margin-left: 5px;
`;

export const StyledCountriesController = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const StyledCountries = styled.div`
  display: flex;
  flex: 1 0 40%;
  margin: 5px 5px 5px 0;
`;

export const StyledMessage = styled.span`
  margin: 5px 5px 0 0;
`;

export const StyledCountriesMessage = styled.div`
  display: flex;
`;
